import { clamp } from './math';

export function hexToRgba(hex: string, a: number): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r},${g},${b},${a})`;
}

export function tintHexWithBlack(hex: string, strength: number): string {
  const tint = clamp(Number.isFinite(strength) ? strength : 0, 0, 1);
  if (!hex || typeof hex !== 'string' || hex.length !== 7 || tint <= 0.0001) {
    return hex;
  }
  const factor = 1 - tint;
  const r = Math.round(parseInt(hex.slice(1, 3), 16) * factor);
  const g = Math.round(parseInt(hex.slice(3, 5), 16) * factor);
  const b = Math.round(parseInt(hex.slice(5, 7), 16) * factor);
  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
}
